// extracted by mini-css-extract-plugin
export default {"body":"styles_body__mv2KJ","addbutton":"styles_addbutton__BCAAZ","actionButton":"styles_actionButton__DseTH"};